export const ACTIVE_STATUSES_TABLE_PARAMS_ID = "activeStatusesTable";
export const JOB_STATUS_LOG_TABLE_PARAMS_ID = "jobStatusLogTable";
